import { Container, Section } from '@styles/global.styled'
import Education from '../Education'
import SuburbContent from '../SuburbContent'
import * as S from './SuburbInfo.styled'

const SuburbInfo = ({ suburb, preamble, article = [], localEducation = [] }) => {
  return (
    <Section withPaddingBottom>
      <Container>
        <S.SuburbInfoContainer>
          {(preamble || (article?.length > 0 && article[0]?.value)) && (
            <S.SuburbInfo>
              <S.SuburbInfoTitle>ABOUT {suburb.toUpperCase()}</S.SuburbInfoTitle>
              {preamble && (
                <S.SuburbInfoPreamble>{preamble}</S.SuburbInfoPreamble>
              )}
              {article?.length > 0 && article[0]?.value && (
                <SuburbContent
                  content={article[0].value}
                  lines={
                    localEducation.length > 0 ? localEducation.length * 2 : 10
                  }
                />
              )}
            </S.SuburbInfo>
          )}
          {localEducation?.length > 0 && (
            <Education title='Education' localEducation={localEducation} />
          )}
        </S.SuburbInfoContainer>
      </Container>
    </Section>
  )
}

export default SuburbInfo
